/**
 * document-routes
 * com.ksoft
 *
 * OpenAPI spec version: 1.1
 * Contact: fposada@ksoftonline.co
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ShowInfoApp } from '../model/showInfoApp';
import { SolicitudPublic } from '../model/solicitudPublic';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SolicitudControllerService {

    protected basePath = 'http://localhost:8083/dr';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param rid 
     * @param cid 
     * @param pid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public aceptarTerminos(rid: any, cid: any, pid: any, observe?: 'body', reportProgress?: boolean): Observable<SolicitudPublic>;
    public aceptarTerminos(rid: any, cid: any, pid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SolicitudPublic>>;
    public aceptarTerminos(rid: any, cid: any, pid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SolicitudPublic>>;
    public aceptarTerminos(rid: any, cid: any, pid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (rid === null || rid === undefined) {
            throw new Error('Required parameter rid was null or undefined when calling aceptarTerminos.');
        }

        if (cid === null || cid === undefined) {
            throw new Error('Required parameter cid was null or undefined when calling aceptarTerminos.');
        }

        if (pid === null || pid === undefined) {
            throw new Error('Required parameter pid was null or undefined when calling aceptarTerminos.');
        }

        let headers = this.defaultHeaders;
        if (rid !== undefined && rid !== null) {
            headers = headers.set('rid', String(rid));
        }
        if (cid !== undefined && cid !== null) {
            headers = headers.set('cid', String(cid));
        }
        if (pid !== undefined && pid !== null) {
            headers = headers.set('pid', String(pid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SolicitudPublic>('post',`${this.basePath}/api/solicitudes/aceptar-terminos`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param rid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOptionsSolicitud(rid: any, observe?: 'body', reportProgress?: boolean): Observable<ShowInfoApp>;
    public getOptionsSolicitud(rid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ShowInfoApp>>;
    public getOptionsSolicitud(rid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ShowInfoApp>>;
    public getOptionsSolicitud(rid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (rid === null || rid === undefined) {
            throw new Error('Required parameter rid was null or undefined when calling getOptionsSolicitud.');
        }

        let headers = this.defaultHeaders;
        if (rid !== undefined && rid !== null) {
            headers = headers.set('rid', String(rid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ShowInfoApp>('get',`${this.basePath}/api/solicitudes/get-options`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param rid 
     * @param cid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSolicitudById(rid: any, cid: any, observe?: 'body', reportProgress?: boolean): Observable<SolicitudPublic>;
    public getSolicitudById(rid: any, cid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SolicitudPublic>>;
    public getSolicitudById(rid: any, cid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SolicitudPublic>>;
    public getSolicitudById(rid: any, cid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (rid === null || rid === undefined) {
            throw new Error('Required parameter rid was null or undefined when calling getSolicitudById.');
        }

        if (cid === null || cid === undefined) {
            throw new Error('Required parameter cid was null or undefined when calling getSolicitudById.');
        }

        let headers = this.defaultHeaders;
        if (rid !== undefined && rid !== null) {
            headers = headers.set('rid', String(rid));
        }
        if (cid !== undefined && cid !== null) {
            headers = headers.set('cid', String(cid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SolicitudPublic>('get',`${this.basePath}/api/solicitudes/get-data.for-ip`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pingSolicitud(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public pingSolicitud(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public pingSolicitud(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public pingSolicitud(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/solicitudes/ping`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
